module.exports = __webpack_public_path__ + "img/speaker20.37eb5cac.png";